import { createServiceStatusStore } from './service-status';

/**
 * App-wide singleton: the admin fetch drives it, and the shell's loading fallback
 * reads it to decide between a plain spinner and the cold-start "waking…" copy.
 */
export const serviceStatusStore = createServiceStatusStore();
